import { Component, Input } from '@angular/core';
import { NgClass, NgStyle } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { SafeHtmlPipe } from '@mwe/ui/pipes';

@Component({
  selector: 'mwe-info-text-card',
  templateUrl: './info-text-card.component.html',
  imports: [NgStyle, NgClass, TranslatePipe, SafeHtmlPipe],
})
export class InfoTextCardComponent {
  @Input() hasBoxStyles = false;
  @Input() noBoxShadow = false;
  @Input() text: string;
  @Input() textParams;
  @Input() dataTest: string;
  @Input() iconClass = 'fa-info-circle';
}
